import { ExternalLink } from 'lucide-react';
import { openWindow, isTauri } from '@/lib/tauri';
import { cn } from '@/lib/utils';

interface PopOutButtonProps {
  /** Slug rendered in the new window, e.g. 'telemetry', 'map', 'fleet' */
  solo: 'telemetry' | 'map' | 'fleet';
  /** Optional robot id appended as &robot=<id> */
  robotId?: string;
  title: string;
  className?: string;
}

export function PopOutButton({ solo, robotId, title, className }: PopOutButtonProps) {
  function pop() {
    const params = new URLSearchParams({ solo });
    if (robotId) params.set('robot', robotId);
    const label = `${solo}-${robotId ?? 'main'}`;
    openWindow({ label, title, url: `/?${params.toString()}` });
  }
  return (
    <button
      onClick={pop}
      title={`Pop out — ${title}${isTauri() ? ' (native window)' : ' (browser tab)'}`}
      className={cn(
        'grid h-6 w-6 place-items-center rounded text-fg-muted hover:bg-surface-2 hover:text-fg-primary',
        className,
      )}
    >
      <ExternalLink className="h-3.5 w-3.5" />
    </button>
  );
}
